export default __webpack_public_path__ + "static/media/Megosu-Animation-Moooi.5966878b.mp4";